/**
 * mobile functionality
 * 
 */
(function () {
  // add "desktop" or "mobile" class to html if not mobile devices
  document.querySelector('html').classList.add(
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
    ? 'mobile'
    : 'desktop'
  )

  // toggle mobile nav
  document.querySelector('html header .menu').addEventListener('click', function (el) {
    if (document.querySelector('header.open')) {
      document.querySelector('header').classList.remove('open')
    } else {
      document.querySelector('header').classList.add('open')
    }
  }, false);
})()